export default "__VITE_ASSET__BaIS8Y7l__"